import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";

export const createCustomer = async (businessId, payload) => {
  try {
    const fingerprint = payload.fingerprint;
    let resp = await http.post(`${URL}/customer/${businessId}/create`, payload);
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};

export const linkGuestCustomer = async ({
  sessionId,
  customerId,
  customerMobile,
  customerName,
}) => {
  try {
    const resp = await http.post(
      `${URL}/tracking/guest/link-customer`,
      {
        sessionId,
        customerId,
        customerMobile,
        customerName,
      }
    );
    return resp;
  } catch (error) {
    console.error("Link guest → customer failed:", error);
  }
};
export const verifyGstForOnlineStore = async (businessId, payload) => {
  try {
    let resp = await http.post(`${URL}/customer/${businessId}/verify-gst`, payload);
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};
export const getCustomer = async (businessId, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(
      `${URL}/customer/${businessId}/get-customer?${queryString}`
    );
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};
export const deleteOneCustomer = async (businessId, customerId) => {
  try {
    const result = await http.delete(
      `${URL}/customer/${businessId}/${customerId}`
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    return error;
  }
};

export const getOneCustomer = async (businessId, customerId) => {
  // console.log("customer Id", customerId);
  try {
    const result = await http.get(
      `${URL}/customer/${businessId}/${customerId}`
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};
export const updateCustomer = async (businessId, customerId, data) => {
  try {
    const result = await http.put(
      `${URL}/customer/${businessId}/${customerId}`,
      data
    );
    return result;
  } catch (error) {
    errorHandler(error);
  }
};

export const bulkUploadCustomers = async (businessId, data) => {
  try {
    const result = await http.post(
      `${URL}/customer/${businessId}/bulk-upload-customer`,
      {
        customers: JSON.stringify(data),
      }
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};

export const updateCustomerSubscription = async (
  businessId,
  customerId,
  data
) => {
  try {
    const result = await http.put(
      `${URL}/customer/sub/${businessId}/${customerId}`,
      data
    );
    // console.log("line no 65", result);
    return result;
  } catch (error) {
    console.log("error", error);
    errorHandler(error);
  }
};
// subscription
export const updateCustomerSubscriptionReceipt = async (
  businessId,
  customerId,
  data
) => {
  try {
    const result = await http.put(
      `${URL}/customer/${businessId}/subscription/${customerId}`,
      data
    );
    // console.log("Line no 77", result);
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};

// /update-sub/:customerId/:productId",
export const updateCustomerSubscriptionData = async (
  businessId,
  customerId,
  productId,
  data
) => {
  try {
    const result = await http.put(
      `${URL}/customer/${businessId}/update-sub/${customerId}/${productId}`,
      data
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};

export const sendCustomerReminder = async (businessId, customerId) => {
  try {
    const result = await http.post(
      `${URL}/customer/${businessId}/${customerId}/send-reminder`
    );
    return result;
  } catch (error) {
    console.error("Error sending customer reminder:", error);
    errorHandler(error);
    throw error;
  }
};